export function removeHyperlinksAndSpecialChars(text: string): string {
  if (!text) {
    return text;
  }

  // Remove hyperlinks
  const withoutHyperlinks = text.replace(/(https?:\/\/[^\s]+)/g, '');

  // Remove special characters except '1'
  const withoutSpecialChars = withoutHyperlinks.replace(/[\/';,?><`~]/g, '');

  return withoutSpecialChars;
}